module.exports = __webpack_public_path__ + "media/images/about-e9ea3a54.png";